// A stout oak: a tapered five-sided trunk under a cluster of faceted leaf
// blobs (low-detail icosahedrons). Ported 1:1 from age-of-mcp's classic
// tree-oak.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.075, 0.12, 0.66, 5),
      color: "#5a3a22", position: [0, 0.33, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.5, 0),
      color: "#3e7d36", position: [0, 1.04, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.36, 0),
      color: "#346a2c", position: [-0.32, 0.86, 0.14] },
    { geometry: new THREE.IcosahedronGeometry(0.34, 0),
      color: "#4f9a3d", position: [0.3, 1.22, -0.12] },
    { geometry: new THREE.IcosahedronGeometry(0.24, 0),
      color: "#5fb04a", position: [0.04, 1.46, 0.2] },
  ];
}

export const treeOak = defineModel({
  id: "tree-oak",
  batchId: "standard",
  name: "Tree oak",
  tags: ["scenery","tree","oak","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tree oak.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.58,
  parts: () => partsFor(),
  animations: [],
});
